import React from "react";
import bots from "../botsData";

const GDPR = () => {
  const botNames = bots.map((bot) => bot.name).join(", ");

  return (
    <div className="relative min-h-screen py-16 px-4">
      <div className="pointer-events-none absolute inset-x-0 top-6 left-1/2 h-px w-[80%] -translate-x-1/2 bg-gradient-to-r from-transparent via-apb-accent-cyan to-transparent opacity-70" />
      <div className="pointer-events-none absolute inset-x-0 top-20 left-0 h-full w-full">
        <div className="mx-auto h-full max-w-6xl bg-[linear-gradient(to_right,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px),linear-gradient(to_bottom,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px)] bg-[length:52px_52px,52px_52px] opacity-10" />
      </div>
      <main className="flex-grow relative z-10">
        <article className="max-w-5xl mx-auto apb-surface-glass p-8 sm:p-10 rounded-2xl mb-16 mt-2 border border-apb-border-soft">
          <div className="inline-flex items-center gap-2 rounded-full border border-apb-border-soft bg-black/20 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-apb-text-secondary">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-apb-accent-cyan apb-glow-cyan" />
            Privacy
          </div>
          <h1 className="text-4xl font-extrabold mt-5 mb-2 apb-glow-text">
            GDPR Privacy Notice
          </h1>
          <p className="text-apb-text-secondary mb-6">Last Updated: January 20, 2026</p>

          <p className="text-lg text-apb-text-secondary mb-5">
            This GDPR Privacy Notice explains how Afterparty BotLabs ("we", "us") processes personal data when you use our Discord
            bots ({botNames}). We are the data controller for data we collect and process through our services.
          </p>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">What data we process</h2>
            <ul className="list-disc list-inside space-y-2 text-apb-text-secondary">
              <li>Discord IDs (user/server/channel/role), usernames, and message metadata.</li>
              <li>Configuration data (e.g., server settings, permissions, command usage).</li>
              <li>Logs and audit events (e.g., moderation actions, errors, uptime).</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">Lawful bases</h2>
            <ul className="list-disc list-inside space-y-2 text-apb-text-secondary">
              <li><strong>Contract:</strong> To provide bot features requested by server admins.</li>
              <li><strong>Legitimate interests:</strong> Security, fraud prevention, service improvement.</li>
              <li><strong>Consent:</strong> Where required for optional analytics or integrations.</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">Retention</h2>
            <p className="text-apb-text-secondary">
              We keep data only as long as needed for the purposes above or as required by law.
              Server owners can request configuration removal; we also remove data on bot removal
              from a server where feasible.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">International transfers</h2>
            <p className="text-apb-text-secondary">
              We may process data in the US or other regions. Where applicable, we use appropriate
              safeguards (e.g., SCCs) for cross-border transfers.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">Your rights (EU/UK)</h2>
            <ul className="list-disc list-inside space-y-2 text-apb-text-secondary">
              <li>Access, rectification, erasure, restriction, objection, and portability.</li>
              <li>Withdraw consent where processing relies on consent.</li>
              <li>Lodge a complaint with your local supervisory authority.</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text mb-2">Requests &amp; contact</h2>
            <p className="text-apb-text-secondary">
              To exercise rights or ask questions, email{" "}
              <a
                href="mailto:support@afterpartylabs.xyz"
                className="text-apb-accent-cyan hover:text-white underline underline-offset-4"
              >
                support@afterpartylabs.xyz
              </a>{" "}
              with your Discord ID and the server/bot context. For verified server owner
              requests we may ask for additional proof of control.
            </p>
          </section>
        </article>
      </main>
    </div>
  );
};

export default GDPR;
